import React from 'react';
import ReactDOM from 'react-dom/client';
import { v4 as uuidv4 } from 'uuid';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Polyfill for crypto.randomUUID in browsers that don't support it
if (!crypto.randomUUID) {
  crypto.randomUUID = () => uuidv4();
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
